import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { MyDocumentsFolderListPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import users from 'modules/core/store/collections/users'

import DocumentURLContext from 'modules/documents/components/Documents/List/DocumentURLContext'
import FolderType from 'modules/documents/components/FolderType'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const FolderPage = () => {
  const {} = useCurrentSession()
  const { navigation } = useNavigation()
  const { folderId } = useParams()
  const employee = users.current.employee
  const [selectedFolder, setSelectedFolder] = useState<Folder | null>()

  const documentRoutesContext = {
    show: (documentId: string | number) =>
      navigation.documents.folderId.documentId.fullPath({
        folderId: Number(folderId),
        document_id: Number(documentId),
      }),
  }

  const { loading, data, error } = useQuery(MyDocumentsFolderListPageDocument, {
    variables: {
      employeeId: employee?.id,
      folderId: Number(folderId),
    },
  })

  const folderOwner = data?.employees?.employee
  const employeeFolder = folderOwner?.folders.find((f) => f.folderId === Number(folderId))
  const folder = data?.documents?.folders[0]

  useUnsafeEffect(() => {
    setSelectedFolder(folder)
  }, [folder])

  const canUploadDocument = (employeeFolder && employeeFolder._policies?.edit.can) ?? false

  const newDocumentUrl = navigation.documents.folderId.new.fullPath({ folderId: Number(folderId) })

  const authorized = folder !== null

  return (
    <DocumentURLContext.Provider value={documentRoutesContext}>
      <ResponsivePage.Body
        loading={loading}
        error={error}
        showHeader={false}
        authorized={authorized}
      >
        {folder && employee && (
          <FolderType
            folder={folder}
            employee={employee}
            parentRoute={navigation.documents.folderId.fullPath({ folderId: folder.id })}
            backActionUrl={newDocumentUrl}
            selectedFolder={selectedFolder}
            onFolderSelected={setSelectedFolder}
            canUploadDocument={canUploadDocument}
          />
        )}
      </ResponsivePage.Body>
    </DocumentURLContext.Provider>
  )
}

export default FolderPage
